import ModeCommentIcon from '@mui/icons-material/ModeComment';
import React from "react";


const ChatBotIcon = ({ icon }: { icon: string | undefined }) => {
    return (
        <>
        { icon ? <img src = { icon } alt = "Chatbot icon" className = "rounded-full mr-2" style={{ width: '40px', height: '40px' }} />: <ModeCommentIcon style={{ fontSize: 30 }} />}
        </>
    );
}

export default ChatBotIcon;